export enum ActionTypes {
  BLOCK_LOAD_START = 'BLOCK_LOAD_START',
  BLOCK_LOAD_FAILED = 'BLOCK_LOAD_FAILED',
  BLOCK_LOAD_SUCCESS = 'BLOCK_LOAD_SUCCESS',
  // TODO: to have a better way to handle state from loading > success > original
  REMOVE_BLOCK_META = 'REMOVE_BLOCK_META',
  RESET_BLOCK_META = 'RESET_BLOCK_META',
}

export interface BlockLoadStart {
  type: ActionTypes.BLOCK_LOAD_START;
  blockId: string;
}

export interface BlockLoadFailed {
  type: ActionTypes.BLOCK_LOAD_FAILED;
  blockId: string;
}

export interface BlockLoadSuccess {
  type: ActionTypes.BLOCK_LOAD_SUCCESS;
  blockId: string;
}

export interface RemoveBlockMeta {
  type: ActionTypes.REMOVE_BLOCK_META;
  blockId: string;
}

export interface ResetBlockMeta {
  type: ActionTypes.RESET_BLOCK_META;
}

export type BlockMetaActions =
  | BlockLoadStart
  | BlockLoadFailed
  | BlockLoadSuccess
  | RemoveBlockMeta
  | ResetBlockMeta;
